import { parse } from "partial-json";

export function handlePartialJSONStream(input: string) {
  if (input === "") {
    return {};
  }
  const cleanedInput = cleanJsonString(input);

  // Fix and close unbalanced JSON elements
  return parse(cleanedInput);
}

function cleanJsonString(input: string) {
  let ret = input;
  ret = ret.replaceAll("\\n", "");
  ret = ret.replaceAll("\\t", "");
  ret = ret.replaceAll("\\", "");

  if (ret.startsWith('"') && ret.endsWith('"')) {
    ret = ret.slice(1, -1);
  }

  const prefixes = ["```json", "```javascript"];
  for (const prefix of prefixes) {
    if (ret.startsWith(prefix)) {
      ret = ret.substring(prefix.length);
      break;
    }
  }

  const noEndingTicks = ret.endsWith("```")
    ? ret.slice(0, -3).trim()
    : ret.trim();
  return noEndingTicks;
}
